import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { homeApi } from '../utils/api';

// GET /me/home, loaded once for the session and shared by Home and the
// sidebar's status lines; `refetch` backs Home's Refresh and Retry.
const HomeSummaryContext = createContext({ summary: null, error: null, loading: false, refetch: async () => {} });

export function HomeSummaryProvider({ children }) {
  const { isSignedIn, isLoaded, getToken } = useAuth();
  const [state, setState] = useState({ summary: null, error: null, loading: false });

  const refetch = useCallback(async () => {
    const token = await getToken();
    if (!token) return;
    setState(s => ({ ...s, loading: true, error: null }));
    try {
      setState({ summary: await homeApi.get(token), error: null, loading: false });
    } catch (e) {
      setState(s => ({ ...s, error: e.message, loading: false }));
    }
  }, [getToken]);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) { setState({ summary: null, error: null, loading: false }); return; }
    refetch();
  }, [isLoaded, isSignedIn, refetch]);

  return <HomeSummaryContext.Provider value={{ ...state, refetch }}>{children}</HomeSummaryContext.Provider>;
}

export function useHomeSummary() {
  return useContext(HomeSummaryContext);
}
